import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../../components/ui/table";
import { useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function TemperatureCheckItemsTable() {
  const token = localStorage.getItem("token");
  const [temperatureCheckItems, setTemperatureCheckItems] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchTemperatureCheckItems = async () => {
    const response = await fetch(`${apiUrl}/temperature_check_items`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    })
    const result = await response.json();
    console.log(result);
    if (result.success) {
      setTemperatureCheckItems(result.temperatureCheckItems);
    } else {
      setTemperatureCheckItems([]);
    }
  };

  useEffect(() => {
    fetchTemperatureCheckItems();
  }, []);

  const handleRowClick = (item: any) => {
    navigate('/update-temperature-check-item', { state: { item } });
  }

  return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Name
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Minimum Temperature
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Maximum Temperature 
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {temperatureCheckItems.map((item) => (
            <TableRow key={item.actempcheck_id} className="cursor-pointer hover:bg-[#ffffa3]"  onClick={() => handleRowClick(item)}>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{item.name}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{item.mintemp}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{item.maxtemp}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  )
}